const base64Encode = async (file: any): Promise<any> =>
  await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      const string = e.target?.result as string;
      resolve(string.split(',')[1]);
    };
    reader.onerror = function () {
      reject(new Error('Something wrong'));
    };
  });

export default base64Encode;
